import React from 'react';
import { FaLinkedin, FaGithub, FaWhatsapp, FaPhone, FaMapMarkerAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";

const Contact = () => {
  const contactInfo = [
    {
      icon: <MdEmail />,
      label: "Email",
      value: "mostafaalmannani@gmail.com",
      link: "mailto:mostafaalmannani@gmail.com",
      color: "from-slate-500 to-cyan-500",
      hoverColor: "hover:from-slate-600 hover:to-cyan-600"
    },
    {
      icon: <FaPhone />,
      label: "Téléphone",
      value: "+212 617 125 803",
      link: "tel:+212617125803",
      color: "from-green-500 to-emerald-500",
      hoverColor: "hover:from-green-600 hover:to-emerald-600"
    },
    {
      icon: <FaWhatsapp />,
      label: "WhatsApp",
      value: "+212 617 125 803",
      link: "https://wa.me/212617125803",
      color: "from-green-400 to-green-600",
      hoverColor: "hover:from-green-500 hover:to-green-700"
    },
    {
      icon: <FaMapMarkerAlt />,
      label: "Localisation",
      value: "Casablanca, Maroc",
      link: "https://maps.google.com/?q=Casablanca,Maroc",
      color: "from-red-500 to-pink-500",
      hoverColor: "hover:from-red-600 hover:to-pink-600"
    },
    {
      icon: <FaLinkedin />,
      label: "LinkedIn",
      value: "mostafa-al-mannani",
      link: "https://www.linkedin.com/in/mostafa-al-mannani/",
      color: "from-slate-600 to-slate-800",
      hoverColor: "hover:from-slate-700 hover:to-slate-900"
    },
    {
      icon: <FaGithub />,
      label: "GitHub",
      value: "MOSTAFA-AL-MANNANI",
      link: "https://github.com/MOSTAFA-AL-MANNANI/",
      color: "from-gray-700 to-gray-900",
      hoverColor: "hover:from-gray-800 hover:to-gray-950"
    }
  ];

  return (
    <section id="contact" className="relative py-16 md:py-20 lg:py-24 overflow-hidden">
      {/* Background gradient same as Hero */}
      <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-slate-900 to-purple-900"></div>
      {/* Animated Background Pattern */}
      <div className="absolute inset-0 bg-black/10">
        <div 
          className="absolute inset-0 animate-pulse opacity-20" 
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          }}
        />
      </div>

      {/* Floating Elements */}
      <div className="absolute top-20 left-10 w-16 h-16 md:w-20 md:h-20 bg-purple-500/20 rounded-full blur-xl animate-bounce" />
      <div className="absolute bottom-20 right-10 w-24 h-24 md:w-32 md:h-32 bg-slate-500/20 rounded-full blur-xl animate-pulse" />
      <div className="absolute top-1/2 left-1/4 w-12 h-12 md:w-16 md:h-16 bg-pink-500/20 rounded-full blur-lg animate-spin" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header Section */}
        <div className="text-center mb-12 md:mb-16 lg:mb-20">
          <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-white mb-4">
            Contact
          </h1>
          <h2 className="text-xl md:text-2xl lg:text-3xl xl:text-4xl font-semibold text-white mb-4">
            Parlons de votre projet
          </h2>
          <p className="text-gray-300 text-base md:text-lg lg:text-xl mt-6 max-w-4xl mx-auto leading-relaxed">
            Prêt à transformer vos idées en réalité ? Contactez-moi pour discuter de votre projet 
            et découvrir comment je peux vous aider à créer quelque chose d'extraordinaire.
          </p>
        </div>
        
        {/* Contact Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8 mb-12 md:mb-16">
          {contactInfo.map((info, index) => (
            <div 
              key={index} 
              className="group bg-white/5 backdrop-blur-md p-4 md:p-6 lg:p-8 rounded-2xl border border-white/10 hover:bg-white/15 hover:border-white/30 transition-all duration-500 transform hover:-translate-y-1 hover:scale-105 shadow-lg hover:shadow-2xl"
            >
              <div className="text-center">
                {/* Icon with gradient background */}
                <div className={`w-14 h-14 md:w-16 md:h-16 lg:w-20 lg:h-20 bg-gradient-to-br ${info.color} ${info.hoverColor} rounded-2xl flex items-center justify-center text-xl md:text-2xl lg:text-3xl mx-auto mb-4 shadow-lg group-hover:shadow-2xl group-hover:scale-110 transition-all duration-300 relative overflow-hidden`}>
                  <div className="absolute inset-0 bg-white/20 group-hover:bg-white/30 transition-all duration-300" />
                  <span className="relative z-10 text-white">{info.icon}</span>
                </div>
                
                {/* Label */}
                <h3 className="font-semibold text-white text-base md:text-lg lg:text-xl mb-2 group-hover:text-purple-300 transition-colors duration-300">
                  {info.label}
                </h3>
                
                {/* Value */}
                <a 
                  href={info.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 text-sm md:text-base group-hover:text-white transition-colors duration-300 break-words block hover:underline"
                >
                  {info.value}
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="text-center mb-12 md:mb-16">
          <div className="bg-gradient-to-r from-purple-500/10 to-pink-500/10 backdrop-blur-md p-6 md:p-8 lg:p-12 rounded-3xl border border-white/10">
            <h3 className="text-xl md:text-2xl lg:text-3xl xl:text-4xl font-bold text-white mb-4">
              Prêt à collaborer ?
            </h3>
            <p className="text-gray-300 text-base md:text-lg lg:text-xl mb-6 md:mb-8 max-w-3xl mx-auto leading-relaxed">
              N'hésitez pas à me contacter pour discuter de vos projets. Je suis disponible pour des collaborations, 
              des consultations ou simplement pour échanger sur le développement web.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center">
              <a 
                href="mailto:mostafaalmannano@gmail.com"
                className="inline-flex border-2 border-white items-center justify-center px-6 md:px-8 py-3 md:py-4 bg-gradient-to-r from-slate-500 to-purple-600 hover:from-slate-600 hover:to-purple-700 text-white font-semibold rounded-xl transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
              >
                <span className="mr-2 text-white"><MdEmail /></span>
                Envoyer un email
              </a>
              <a 
                href="https://wa.me/212617359379"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center border-2 border-white px-6 md:px-8 py-3 md:py-4 bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white font-semibold rounded-xl transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
              >
                <span className="mr-2 text-white"><FaWhatsapp /></span>
                WhatsApp
              </a>
            </div>
          </div>
        </div>

        {/* Social Links */}
        <div className="text-center">
          <h4 className="text-lg md:text-xl lg:text-2xl font-semibold text-white mb-6">Suivez-moi</h4>
          <div className="flex justify-center space-x-3 md:space-x-4 lg:space-x-6">
            <a 
              href="https://www.linkedin.com/in/mostafa-al-mannani-bb0937293/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 md:w-14 md:h-14 border-2 border-white bg-gradient-to-r from-slate-600 to-slate-800 hover:from-slate-700 hover:to-slate-900 backdrop-blur-md rounded-xl flex items-center justify-center transition-all duration-300 transform hover:scale-110 shadow-lg hover:shadow-xl"
              aria-label="LinkedIn"
            >
              <svg className="w-5 h-5 md:w-6 md:h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
            </a>
            <a 
              href="https://github.com/MOSTAFA-AL-MANNANI/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 md:w-14 md:h-14 border-2 border-white bg-gradient-to-r from-gray-700 to-gray-900 hover:from-gray-800 hover:to-gray-950 backdrop-blur-md rounded-xl flex items-center justify-center transition-all duration-300 transform hover:scale-110 shadow-lg hover:shadow-xl"
              aria-label="GitHub"
            >
              <svg className="w-5 h-5 md:w-6 md:h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
              </svg>
            </a>
            <a 
              href="https://wa.me/212617359379"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 md:w-14 md:h-14 border-2 border-white bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 backdrop-blur-md rounded-xl flex items-center justify-center transition-all duration-300 transform hover:scale-110 shadow-lg hover:shadow-xl"
              aria-label="WhatsApp"
            >
              <svg className="w-5 h-5 md:w-6 md:h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact; 